import { render, staticRenderFns } from "./ShowMovementPage.vue?vue&type=template&id=412e1620&scoped=true"
import script from "./ShowMovementPage.vue?vue&type=script&lang=js"
export * from "./ShowMovementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e1620",
  null
  
)

export default component.exports